import React, { useState } from "react";
import {
  Table,
  Button,
  Input,
  Card,
  Space,
  Breadcrumb,
  Typography,
} from "antd";
import { PlusOutlined, SearchOutlined, ReloadOutlined } from "@ant-design/icons";

const { Title } = Typography;

export default function PageTableLayout({
  breadcrumb = [],
  title = "",
  addButtonLabel,
  onAdd,
  columns = [],
  dataSource = [],
  loading = false,
  onRefresh,
  rowKey = "id",
  pageSize = 10,
  tableProps = {},
}) {
  const [searchText, setSearchText] = useState("");

  const filteredData = searchText
    ? dataSource.filter((row) =>
        Object.values(row)
          .join(" ")
          .toLowerCase()
          .includes(searchText.toLowerCase())
      )
    : dataSource;

  const breadcrumbItems = breadcrumb.map((label) => ({ title: label }));

  return (
    <div style={{ background: "#fff", minHeight: "100vh", padding: 24 }}>
      {/* Header */}
      <Card
        style={{ marginBottom: 16 }}
        headStyle={{ backgroundColor: "#722ed1", color: "#fff" }} 
        title={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Title level={3} style={{ margin: 0, color: "#fff" }}>
              {title}
            </Title>
            {addButtonLabel && (
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={onAdd}
              >
                {addButtonLabel}
              </Button>
            )}
          </div>
        }
      >
        {breadcrumbItems.length > 0 && (
          <Breadcrumb items={breadcrumbItems} style={{ marginBottom: 8 }} />
        )}
      </Card>

      {/* Search */}
      <Card style={{ marginBottom: 16 }}>
        <Space style={{ width: "100%", justifyContent: "space-between" }}>
          <Input
            placeholder="Search"
            prefix={<SearchOutlined />}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            allowClear
            style={{ width: 300 }}
          />
          <Button icon={<ReloadOutlined />} onClick={onRefresh}>
            Refresh
          </Button>
        </Space>
      </Card>

      {/* Table */}
      <Card>
        <Table
          dataSource={filteredData}
          columns={columns}
          rowKey={rowKey}
          loading={loading}
          pagination={{ pageSize }}
          {...tableProps}
        />
      </Card>
    </div>
  );
}
